<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Detalle General</p>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="12" class="centrarBoton">
                        <v-btn @click="$router.push({ name: 'FinanzasPrincipal' }).catch((error) => error);"
                            class="ma-2" color="error">
                            Regresar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="8">
                            <v-row class="mt-2 ">
                                <v-col cols="12" md="6" class="centrarBoton">
                                    <v-btn-toggle divided variant="outlined" color="primary">
                                        <v-tooltip v-if="mostrarNoti" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="NotificarFianza()" icon>
                                                    <v-icon>mdi-email-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Notificación de presentación</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarLimpiar" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="LimpiarFianzas()" icon>
                                                    <v-icon>mdi-eraser</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Limpiar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarAsig" top>
                                            <template v-slot:activator="{ on, attrs }">

                                                <v-btn v-on="on" v-bind="attrs" @click="AsignarFinanzas()" icon>
                                                    <v-icon>mdi-table-edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Asignar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarUti" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="UtilizarFianza()" icon>
                                                    <v-icon>mdi-zip-box</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Utilizar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarRecib" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="RecibirFianza()" icon>
                                                    <v-icon>mdi-hand-pointing-left</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Recibir Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarCan" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="CancelarFianzas()" icon>
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Cancelar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarUndo" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="RecuperarFianza()" icon>
                                                    <v-icon>mdi-undo-variant</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Recuperar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarRes" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" @click="ResguardarFianza()" icon>
                                                    <v-icon>mdi-lock</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Resguardar Fianza</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="mostrarEfec" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-on="on" v-bind="attrs" icon @click="EfectivaFianza()">
                                                    <v-icon>mdi-lightbulb-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Hacer efectiva</span>
                                        </v-tooltip>
                                    </v-btn-toggle>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="4">
                        <label class="typo__label">Folio:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifolio }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Afianzadora:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.afnombre }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Responsable:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.responsable }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Estatus:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fiestatus }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Monto:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fimonto }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                    </v-col>
                    <v-col cols="12" md="4">
                        <label class="typo__label">Reporte:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.nrreporte }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Indice:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.svindice }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Atendio:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.prnombre }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Importe:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fiimporte }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Prima:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fiprima }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Concepto de uso:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.ficpto }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="6" md="4">
                        <label class="typo__label">Dada de alta el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecalta }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Caduca el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifeccad }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Asignada el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecasig }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Recibida el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecrecibida }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Utilizada el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecaplic }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Recuperada el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecrecup }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Inutilizada el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifeccancel }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Efectiva el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecefectiva }}
                        </label>
                        <v-divider class="ma-2"></v-divider>
                        <label class="typo__label">Entregada el:</label>
                        <br>
                        <label class="typo__label font-weight-bold sub-Fia">
                            {{ this.datos.fifecentregada }}
                        </label>
                        <v-btn
                            v-if="(datos.fifecentregada == '' || datos.fifecentregada == null) && mostraredit == false"
                            @click="editarFecha()" icon>
                            <v-icon color="#536DFE">mdi-lead-pencil</v-icon>
                        </v-btn>
                        <v-btn v-if="mostraredit" @click="guardarFecha()" icon>
                            <v-icon color="success">mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn v-if="mostraredit" @click="cancelarFecha()" icon>
                            <v-icon color="secondary">mdi-keyboard-return</v-icon>
                        </v-btn>

                        <v-dialog v-if="mostraredit" ref="dialog" outlined v-model="modal"
                            :return-value.sync="selectedDate" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <div class="date-align-center">
                                    <v-text-field v-model="selectedDate" label="" readonly outlined dense v-bind="attrs"
                                        v-on="on" ref="selectedDate"></v-text-field>
                                </div>
                            </template>
                            <v-date-picker v-model="selectedDate" locale="es-mx" :min="startdate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(selectedDate)">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                        <v-divider class="ma-2"></v-divider>
                    </v-col>
                    <v-col cols="6" md="4">
                        <div v-if="datos.ficpto == 'Inclusión varios'">
                            <div v-for="(item, index) in datosConcepto" :key="index">
                                <label class="typo__label">Concepto:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ item.fccpto }}
                                </label>
                                <v-divider class="ma-2"></v-divider>
                                <label class="typo__label">Monto:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ item.ficexhibe }}
                                </label>
                                <v-divider class="ma-2"></v-divider>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';
import moment from "moment";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            showcargando: true,
            datos: [],
            datosConcepto: [],
            //Alta
            modal: false,
            showAfian: false,
            showAlertIni: false,
            showAlertFin: false,
            //Botones
            mostrarAsig: true,
            mostrarUti: true,
            mostrarCan: true,
            mostrarRes: true,
            mostrarUndo: true,
            mostrarRecib: true,
            mostrarNoti: true,
            mostrarEfec: true,
            mostrarLimpiar: true,

            mostraredit: false,
            selectedDate: null,

            permisoContraloria: false,
            permisoAltaFianza: false,
            permisoLimpiarFianza: false,
            permisoAsignar: false,
            permisoFianza: false,
            uslogin: ''
        }
    },
    watch: {
        'datosBusqueda.prefijo'(val) {
            this.showAlertIni = false;
            this.showAlertFin = false;
        },
        'datosBusqueda.folioIni'(val) {
            this.showAlertIni = false;
        },
        'datosBusqueda.folioFin'(val) {
            this.showAlertFin = false;
        },
        'datosBusqueda.sufijo'(val) {
            this.showAlertIni = false;
            this.showAlertFin = false;
        },
        'datosBusqueda.afianzadora'(val) {
            this.showAfian = false;
        },
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '15,16,20,22,317').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(object => {
                    if (object.peclave == 15)
                        this.permisoContraloria = true;
                    else if (object.peclave == 16)
                        this.permisoAltaFianza = true;
                    else if (object.peclave == 20)
                        this.permisoLimpiarFianza = true;
                    else if (object.peclave == 22)
                        this.permisoAsignar = true;
                    else if (object.peclave == 317)
                        this.permisoFianza = true;
                });
            }
        });

        if (this.permisoContraloria == false || this.permisoFianza == false) {
            this.$router.push({ name: `NoAutorizado` }).catch(error => error);
        }
    },
    methods: {
        limpiar() {
            this.datosBusqueda.monto = null;
            this.datosBusqueda.afianzadora = null;
            this.datosBusqueda.prefijo = null;
            this.datosBusqueda.folioIni = null;
            this.datosBusqueda.folioFin = null;
            this.datosBusqueda.sufijo = null;
            this.datosBusqueda.selectedDate = null;
        },
        async AsignarFinanzas() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'AsignarFianza' }).catch((error) => error);
        },
        async RecibirFianza() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'RecibirFianza' }).catch((error) => error);
        },
        async UtilizarFianza() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'UtilizarFianza' }).catch((error) => error);
        },
        async NotificarFianza() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'NotificarFianza' }).catch((error) => error);
        },
        async editarFecha() {
            this.mostraredit = true;
        },
        async cancelarFecha() {
            this.mostraredit = false;
            this.selectedDate = moment().format("YYYY[-]MM[-]DD");
        },
        async guardarFecha() {
            this.$swal({
                position: 'center',
                title: 'Guardando fecha ...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var formData = new FormData();
                    formData.append("fecha", this.selectedDate);
                    formData.append("afclave", this.datos.afclave);
                    formData.append("fifolio", this.datos.fifolio);
                    let response = await Fianzas.guardarFecha(formData);
                    if (response != false) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se actualizó la fecha correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            var fecha = response[0];
                            this.mostraredit = false;
                            this.datos.fifecentregada = fecha.fifecentregada;
                        });
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Correcto',
                            text: 'OOcurrió un error, al editar la fecha, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }

                }
            });
        },

        async ResguardarFianza() {
            this.$swal({
                position: 'center',
                icon: 'info',
                title: '¿Está seguro que desea resguardar la fianza?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Resguardando fianza ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            var formData = new FormData();
                            formData.append("afclave", this.datos.afclave);
                            formData.append("fifolio", this.datos.fifolio);
                            let response = await Fianzas.ResguardarFianza(formData);
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se resguardó la fianza correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.DetalleFianza();
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurrió un error, al resguardar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }
                    });
                }
            })
        },
        async CancelarFianzas() {
            this.$swal({
                position: 'center',
                icon: 'info',
                title: '¿Está seguro que desea cancelar la fianza?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Cancelando fianza ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            var formData = new FormData();
                            formData.append("afclave", this.datos.afclave);
                            formData.append("fifolio", this.datos.fifolio);
                            formData.append("uslogin", this.uslogin);
                            let response = await Fianzas.CancelarFianzas(formData);
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se canceló la fianza correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.DetalleFianza();
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurrió un error, al cancelar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }
                    });
                }
            })
        },
        async LimpiarFianzas() {
            this.$swal({
                position: 'center',
                icon: 'info',
                title: '¿Está seguro que desea limpiar la fianza?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Limpiando fianza ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            var formData = new FormData();
                            formData.append("afclave", this.datos.afclave);
                            formData.append("fifolio", this.datos.fifolio);
                            let response = await Fianzas.LimpiarFianzas(formData);
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se limpió la fianza correctamente.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.DetalleFianza();
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurrió un error, al limpiar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }
                    });
                }
            })
        },
        async RecuperarFianza() {
            this.$swal({
                position: 'center',
                icon: 'info',
                title: '¿Está seguro que desea recuperar la fianza?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Recuperando fianza ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            var formData = new FormData();
                            formData.append("afclave", this.datos.afclave);
                            formData.append("fifolio", this.datos.fifolio);
                            let response = await Fianzas.RecuperarFianza(formData);
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se recuperó la fianza correctamente.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.DetalleFianza();
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurrió un error, al recuperar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }
                    });
                }
            })
        },
        async EfectivaFianza() {
            this.$swal({
                position: 'center',
                icon: 'info',
                title: '¿Está seguro que desea hacer efectiva la fianza?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Haciendo efectiva fianza ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            var formData = new FormData();
                            formData.append("afclave", this.datos.afclave);
                            formData.append("fifolio", this.datos.fifolio);
                            let response = await Fianzas.HacerEfectiva(formData);
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se hizó efectiva la fianza correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.DetalleFianza();
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurrió un error, al hacer efectiva la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }
                    });
                }
            })
        },
        async DetalleFianza() {
            this.showcargando = true;

            let datosFianza = await MetodosGenerales.obtenerSessionReporte('fianza');
            var formData = new FormData();
            formData.append("afianzadora", datosFianza.afclave);
            formData.append("folio", datosFianza.fifolio);
            this.datos = await Fianzas.DetalleFianza(formData);

            if (this.datos.ficpto != null && this.datos.ficpto != "") {
                var formConcepto = new FormData();
                formConcepto.append("afclave", this.datos.afclave);
                formConcepto.append("fifolio", this.datos.fifolio);

                this.datosConcepto = await Fianzas.ObtenerFianzaConceptos(formConcepto);
            }

            this.startdate = moment().format("YYYY[-]MM[-]DD");
            this.selectedDate = moment().format("YYYY[-]MM[-]DD");

            this.mostrarAsig = true;
            this.mostrarUti = true;
            this.mostrarCan = true;
            this.mostrarRes = true;
            this.mostrarUndo = true;
            this.mostrarRecib = true;
            this.mostrarNoti = true;
            this.mostrarEfec = true;
            this.mostrarLimpiar = true;

            if (this.datos.firecup == true || this.datos.fiestatus == "Inutilizada" || this.datos.fiestatus == "Utilizada" || this.datos.fiestatus == "Vencida" || this.permisoAsignar == false || this.datos.fiefectiva == true) {
                this.mostrarAsig = false;
            }

            if (this.datos.firecup == true || this.datos.fiestatus == "Inutilizada" || this.datos.fiestatus == "Utilizada" || this.datos.fiestatus == "Sin uso" || this.datos.fiestatus == "Resguardo" || this.datos.fiefectiva == true) {
                this.mostrarUti = false;
            }

            if (this.datos.fiestatus == "Utilizada" || this.datos.fiestatus == "Inutilizada" || this.datos.fiestatus == "Sin uso" || this.datos.fiefectiva == true) {
                this.mostrarCan = false;
            }

            if (this.datos.firecup == true || this.datos.fiestatus == "Utilizada" || this.datos.fiestatus == "Inutilizada" || this.datos.fiestatus == "Sin uso" || this.datos.fiestatus == "Resguardo" || this.datos.fiefectiva == true) {
                this.mostrarRes = false;
            }

            if (this.datos.firecup == true || this.datos.fiestatus != "Utilizada" || this.datos.fiestatus == "Sin uso" || this.datos.fiefectiva == true) {
                this.mostrarUndo = false;
            }

            if ((this.datos.fiestatus != "Utilizada" && this.datos.fiestatus != "Inutilizada" && this.datos.fiestatus != "Vencida") || this.datos.firecibida == true || this.datos.fiefectiva == true) {
                this.mostrarRecib = false;
            }

            if (this.datos.nrreporte == null || this.datos.nrreporte == '') {
                this.mostrarNoti = false;
            }

            if (this.datos.fiestatus != "Utilizada" || this.datos.fiefectiva == true || this.datos.firecup == true) {
                this.mostrarEfec = false;
            }

            if (this.datos.fiestatus == "Asignada" || this.datos.fiestatus == "Sin uso" || this.datos.fiestatus == "Resguardo" || this.datos.fiestatus == "Inutilizada" || this.datos.fifecentregada != "" || this.datos.fifecrecibida != "" || this.permisoLimpiarFianza == false || this.datos.firecup == true || this.datos.fiefectiva == true) {
                this.mostrarLimpiar = false;

            }
            this.showcargando = false;
        }
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        await this.DetalleFianza();

    },
}
</script>

<style scoped>
.sub-Fia {
    font-size: 18px;
}



.button-container {
    display: flex;
}

.align-left-button {
    float: left;
    width: auto;
}

.align-right-button {
    float: left;
    width: 20px !important;
    height: 40px !important;
}

@media screen and (max-width: 959px) {
    .centrarBoton {
        display: grid !important;
        place-items: center !important;
    }
}

/* @media screen and (max-width: 959px) {
    .centrarBoton {
        display: grid !important;
        place-items: center !important;
    }
} */

.botonRegresar {
    margin-left: 30px;
}

.centrartexto {
    text-align: center;
}
</style>
